import {GetRefundStates} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {RemoteRefundGetStates} from 'data/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {RefundFlowEndPoints} from '../../../endpoints';

export const makeGetRefundStates = (): GetRefundStates =>
	new RemoteRefundGetStates(
		makeBFFApiUrl(RefundFlowEndPoints.states),
		makeAuthorizeHttpClientDecorator(),
	);
